/* =========================================================
   Fem Crochets — interactie
   Zelfde gedrag als de oorspronkelijke site, maar het
   winkelmandje praat nu met de echte Shopify-cart.
   ========================================================= */
(function () {
  'use strict';

  var R = (window.FEM && window.FEM.routes) || {};
  var T = (window.FEM && window.FEM.teksten) || {};

  /* ---------- meldingsbalkje ---------- */
  function toast(tekst) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = tekst;
    requestAnimationFrame(function () { el.classList.add('show'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('show'); }, 2800);
  }

  /* ---------- hoogte van de kop meten, zodat de opening precies het scherm vult ---------- */
  function meetKop() {
    var balk = document.querySelector('.announce');
    var kop = document.querySelector('.site-head');
    var totaal = (balk ? balk.offsetHeight : 0) + (kop ? kop.offsetHeight : 0);
    document.documentElement.style.setProperty('--head', totaal + 'px');
  }
  meetKop();
  window.addEventListener('resize', meetKop);
  window.addEventListener('load', meetKop);

  /* ---------- de titelfont zet de letter na een kleine d te dicht tegen die d aan ----------
     Op de oude site stond dit in de HTML. Productnamen komen nu uit Shopify,
     dus wordt het hier bij het laden gedaan.                                              */
  function ruimteNaD(wortel) {
    var koppen = (wortel || document).querySelectorAll('h1,h2,h3,h4');
    koppen.forEach(function (kop) {
      if (kop.dataset.kd) return;
      kop.dataset.kd = '1';
      var loper = document.createTreeWalker(kop, NodeFilter.SHOW_TEXT, null);
      var knopen = [];
      while (loper.nextNode()) knopen.push(loper.currentNode);
      knopen.forEach(function (knoop) {
        if (knoop.nodeValue.indexOf('d') === -1) return;
        var vak = document.createElement('span');
        vak.innerHTML = knoop.nodeValue.replace(/&/g, '&amp;').replace(/</g, '&lt;')
                                       .replace(/d/g, '<span class="kd">d</span>');
        knoop.parentNode.replaceChild(vak, knoop);
      });
    });
  }

  /* ---------- mobiel menu ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.burger')) {
      var menu = document.querySelector('.menu');
      if (menu) menu.classList.toggle('open');
    }
  });

  /* =========================================================
     Winkelmandje via de Shopify cart-API
     ========================================================= */
  function ververs(secties) {
    // Shopify stuurt de opnieuw getekende secties mee terug
    if (!secties) return false;
    var gedaan = false;
    Object.keys(secties).forEach(function (naam) {
      var doel = document.getElementById('shopify-section-' + naam);
      if (!doel || !secties[naam]) return;
      var pot = document.createElement('div');
      pot.innerHTML = secties[naam];
      var nieuw = pot.querySelector('#shopify-section-' + naam) || pot.firstElementChild;
      if (nieuw) { doel.replaceWith(nieuw); gedaan = true; }
    });
    if (gedaan) { ruimteNaD(); meetKop(); }
    return gedaan;
  }

  function sectieNamen() {
    var namen = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      var naam = el.id.replace('shopify-section-', '');
      if (naam === 'header' || naam.indexOf('cart') !== -1 || naam === 'main') namen.push(naam);
    });
    return namen.join(',');
  }

  function wijzigRegel(sleutel, aantal) {
    fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: sleutel, quantity: aantal, sections: sectieNamen() })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!ververs(data.sections)) window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-plus],[data-min],[data-weg]');
    if (!knop) return;
    e.preventDefault();
    var sleutel = knop.dataset.plus || knop.dataset.min || knop.dataset.weg;
    var veld = document.querySelector('[data-aantal="' + sleutel + '"]');
    var nu = veld ? parseInt(veld.value, 10) || 0 : 0;
    if (knop.dataset.weg) wijzigRegel(sleutel, 0);
    else wijzigRegel(sleutel, knop.dataset.plus ? nu + 1 : Math.max(0, nu - 1));
  });

  document.addEventListener('change', function (e) {
    var veld = e.target.closest('[data-aantal]');
    if (!veld) return;
    wijzigRegel(veld.dataset.aantal, Math.max(0, parseInt(veld.value, 10) || 0));
  });

  /* ---------- aantal op de productpagina ---------- */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-aantal-min],[data-aantal-plus]');
    if (!knop) return;
    var veld = knop.parentNode.querySelector('input[name="quantity"]');
    if (!veld) return;
    var nu = parseInt(veld.value, 10) || 1;
    veld.value = knop.hasAttribute('data-aantal-plus') ? nu + 1 : Math.max(1, nu - 1);
  });

  /* ---------- toevoegen aan de tas ---------- */
  document.querySelectorAll('[data-toevoegformulier]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var knop = form.querySelector('[data-toevoegknop]');
      var fout = form.querySelector('[data-toevoegfout]');
      if (fout) { fout.hidden = true; fout.textContent = ''; }
      if (knop) knop.disabled = true;

      var data = new FormData(form);
      data.append('sections', sectieNamen());

      fetch(R.cart_add, { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (fout) { fout.textContent = res.body.description || res.body.message || ''; fout.hidden = false; }
            return;
          }
          ververs(res.body.sections);
          toast((res.body.product_title || res.body.title || '') + ' ' + (T.toegevoegd || ''));
          telBij();
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (knop) knop.disabled = false; });
    });
  });

  function telBij() {
    fetch(R.cart, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.bag').forEach(function (b) {
          b.textContent = b.textContent.replace(/\(\d+\)/, '(' + c.item_count + ')');
          b.classList.toggle('vol', c.item_count > 0);
        });
      })
      .catch(function () {});
  }

  /* ---------- varianten ---------- */
  document.querySelectorAll('[data-variantkiezer]').forEach(function (kiezer) {
    var form = kiezer.closest('form');
    if (!form) return;

    function pasAan() {
      var gekozen = [];
      form.querySelectorAll('[data-optie]').forEach(function (groep) {
        var aan = groep.querySelector('input:checked');
        gekozen.push(aan ? aan.value : '');
      });
      var raak = null;
      Array.prototype.forEach.call(kiezer.options, function (optie) {
        var delen = optie.dataset.titel.split(' / ');
        var gelijk = gekozen.every(function (waarde, i) { return delen[i] === waarde; });
        if (gelijk) raak = optie;
      });
      if (!raak) return;
      kiezer.value = raak.value;

      var prijs = document.querySelector('[data-prijs]');
      if (prijs) prijs.textContent = raak.dataset.prijs;

      gekozen.forEach(function (waarde, i) {
        var uit = form.querySelector('[data-gekozen="' + i + '"]');
        if (uit) uit.textContent = waarde;
      });

      var knop = form.querySelector('[data-toevoegknop]');
      if (knop) {
        var kan = raak.dataset.beschikbaar === 'true';
        knop.disabled = !kan;
        knop.textContent = kan ? knop.dataset.aan || knop.textContent : (knop.dataset.uit || knop.textContent);
      }
    }

    form.querySelectorAll('[data-optie] input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var groep = radio.closest('[data-optie]');
        groep.querySelectorAll('.keuze').forEach(function (l) { l.classList.remove('on'); });
        radio.closest('.keuze').classList.add('on');
        pasAan();
      });
    });
  });

  /* ---------- kleurkeuze op de personaliseerpagina ---------- */
  document.querySelectorAll('.kiezer [data-group]').forEach(function (groep) {
    groep.addEventListener('change', function (e) {
      var radio = e.target.closest('input[type="radio"]');
      if (!radio) return;
      groep.querySelectorAll('.bolkeuze').forEach(function (l) { l.classList.remove('on'); });
      radio.closest('.bolkeuze').classList.add('on');

      var naam = groep.dataset.group;
      var uit = document.querySelector('[data-out="' + naam + '"]');
      if (uit) uit.textContent = radio.value;
      var proef = document.querySelector('[data-preview="' + naam + '"]');
      if (proef && radio.dataset.kleur) proef.style.setProperty('--a', radio.dataset.kleur);
    });
  });

  /* ---------- fotogalerij ---------- */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('.gal .strip button');
    if (!knop) return;
    var strip = knop.parentNode;
    strip.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
    knop.classList.add('on');
    var groot = document.querySelector('[data-main]');
    var klein = knop.querySelector('img');
    if (groot && klein) {
      groot.src = klein.dataset.groot || klein.src;
      groot.alt = klein.alt;
    }
  });

  /* ---------- filteren op kleur ----------
     Dit luistert op het hele document en niet op de balk zelf. Zo blijft het
     werken als Shopify de sectie opnieuw tekent, bijvoorbeeld in de
     thema-editor, en maakt het niet uit in welke volgorde de pagina laadt. */
  document.addEventListener('click', function (e) {
    var balk = e.target.closest('.colorbar[data-group="kleur"]');
    if (!balk) return;
    var knop = e.target.closest('button');
    if (!knop) return;

    balk.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
    knop.classList.add('on');

    var waarde = (knop.dataset.value || '').trim().toLowerCase();
    var zichtbaar = 0;
    document.querySelectorAll('.grid [data-kleur]').forEach(function (kaart) {
      var kleuren = (kaart.dataset.kleur || '').toLowerCase().split(/\s+/);
      var raak = waarde === 'alles' || kleuren.indexOf(waarde) !== -1;
      kaart.style.display = raak ? '' : 'none';
      if (raak) zichtbaar++;
    });

    var teller = document.querySelector('[data-count]');
    if (teller) teller.textContent = zichtbaar + (zichtbaar === 1 ? ' combinatie' : ' combinaties');
  });

  /* ---------- uitklapbare informatie ---------- */
  document.addEventListener('click', function (e) {
    var vraag = e.target.closest('.facts .q');
    if (!vraag) return;
    vraag.closest('.row').classList.toggle('open');
  });

  function openVraagUitAdres() {
    if (!window.location.hash) return;
    var doel = document.getElementById(window.location.hash.slice(1));
    if (!doel) return;
    var rij = doel.closest ? doel.closest('.row') : null;
    if (rij) { rij.classList.add('open'); rij.scrollIntoView({ block: 'center' }); }
  }
  openVraagUitAdres();
  window.addEventListener('hashchange', openVraagUitAdres);

  /* ---------- bewaren ---------- */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-save]');
    if (!knop) return;
    var bewaard = knop.classList.toggle('saved');
    toast(bewaard ? (T.bewaard || '') : (T.bewaard_uit || ''));
  });

  /* =========================================================
     Zoeken
     ========================================================= */
  var laag = document.querySelector('[data-zoeklaag]');
  var indexEl = document.querySelector('[data-zoekindex]');
  if (laag && indexEl) {
    var index = [];
    var tips = [];
    try { index = JSON.parse(indexEl.textContent) || []; } catch (e) { index = []; }
    try {
      var tipsEl = document.querySelector('[data-zoektips]');
      tips = tipsEl ? (JSON.parse(tipsEl.textContent) || []) : [];
      tips = tips.map(function (s) { return String(s).trim(); }).filter(Boolean);
    } catch (e) { tips = []; }

    var veld = laag.querySelector('[data-zoek-veld]');
    var uit = laag.querySelector('[data-zoek-uit]');

    function plat(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function zoek(vraag) {
      var delen = plat(vraag).split(/\s+/).filter(Boolean);
      if (!delen.length) return null;
      return index.map(function (r) {
        var hooi = plat(r.titel + ' ' + r.bij + ' ' + r.woorden);
        var titel = plat(r.titel);
        var punten = 0;
        for (var i = 0; i < delen.length; i++) {
          if (hooi.indexOf(delen[i]) === -1) return null;
          if (titel.indexOf(delen[i]) === 0) punten += 3;
          else if (titel.indexOf(delen[i]) !== -1) punten += 2;
          else punten += 1;
        }
        return { r: r, punten: punten };
      }).filter(Boolean).sort(function (a, b) { return b.punten - a.punten; })
        .map(function (x) { return x.r; });
    }

    function veilig(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function regel(r) {
      var beeld = r.foto
        ? '<span class="zoek-foto"><img src="' + veilig(r.foto) + '" alt=""></span>'
        : '<span class="zoek-foto leeg" aria-hidden="true"></span>';
      return '<a class="zoek-regel" href="' + veilig(r.url) + '">' + beeld +
             '<span class="zoek-tekst"><b>' + veilig(r.titel) + '</b><span>' + veilig(r.bij) + '</span></span></a>';
    }

    function suggesties() {
      if (!tips.length) { uit.innerHTML = ''; return; }
      uit.innerHTML = '<div class="zoek-kop">Waar vaak naar gezocht wordt</div>' +
        '<div class="zoek-tips">' + tips.map(function (t) {
          return '<button type="button" data-tip="' + veilig(t) + '">' + veilig(t) + '</button>';
        }).join('') + '</div>';
    }

    function toon() {
      var vraag = veld.value.trim();
      var gevonden = zoek(vraag);
      if (gevonden === null) return suggesties();
      if (!gevonden.length) {
        uit.innerHTML = '<div class="zoek-niets">' + veilig(T.niets_gevonden || 'Niets gevonden voor') +
          ' <b>' + veilig(vraag) + '</b>.</div>';
        return;
      }
      var groepen = [['Slofjes', 'Slofjes'], ['Vraag', 'Veelgestelde vragen'], ['Pagina', "Pagina's"]];
      uit.innerHTML = groepen.map(function (g) {
        var rijen = gevonden.filter(function (r) { return r.soort === g[0]; });
        if (!rijen.length) return '';
        return '<div class="zoek-kop">' + g[1] + '</div>' + rijen.map(regel).join('');
      }).join('');
    }

    function openZoek() {
      laag.hidden = false;
      document.body.classList.add('vast');
      veld.value = '';
      suggesties();
      setTimeout(function () { veld.focus(); }, 30);
    }
    function sluitZoek() {
      laag.hidden = true;
      document.body.classList.remove('vast');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-zoek-open]')) { e.preventDefault(); openZoek(); }
    });
    laag.querySelector('[data-zoek-dicht]').addEventListener('click', sluitZoek);
    laag.addEventListener('click', function (e) { if (e.target === laag) sluitZoek(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !laag.hidden) sluitZoek();
    });
    veld.addEventListener('input', toon);
    uit.addEventListener('click', function (e) {
      var tip = e.target.closest('[data-tip]');
      if (!tip) return;
      veld.value = tip.dataset.tip;
      toon();
      veld.focus();
    });
  }

  /* =========================================================
     Leespagina's: algemene voorwaarden, privacy, verzenden
     Shopify levert de tekst als gewone koppen en alinea's aan.
     Hier krijgen ze de opmaak van de oude site terug: het
     nummer als apart labeltje, en de invulregels lichter.
     ========================================================= */
  (function juridisch() {
    var blok = document.querySelector('.tekst');
    if (!blok) return;

    blok.querySelectorAll('h2, h3').forEach(function (kop) {
      if (kop.querySelector('.art')) return;
      var tekst = kop.textContent.trim();
      var m = tekst.match(/^(Artikel\s+\d+|Bijlage)\s*[\u2013\u2014-]\s*(.+)$/i);
      if (!m) return;
      kop.textContent = '';
      var label = document.createElement('span');
      label.className = 'art';
      label.textContent = m[1];
      kop.appendChild(label);
      kop.appendChild(document.createTextNode(m[2]));
    });

    blok.querySelectorAll('p').forEach(function (regel) {
      var tekst = regel.textContent.trim();
      if (!tekst) return;
      // regels die alleen uit puntjes bestaan zijn invulregels
      if (/^[\u2026.\s]+$/.test(tekst) && tekst.length > 6) {
        regel.classList.add('invulregel');
      } else if (tekst.charAt(0) === '(' && tekst.charAt(tekst.length - 1) === ')') {
        regel.classList.add('noot');
      }
    });
  })();

  // eerst de artikelkoppen opbouwen, dan pas de letterafstand zetten
  ruimteNaD();

  /* ---------- in de thema-editor opnieuw opbouwen ---------- */
  document.addEventListener('shopify:section:load', function () { ruimteNaD(); meetKop(); });
})();
